var path = '/templates/projects/views/directives/project_search.html';
var html = "<input type=text ng-model=selectedProject class=\"form-control project-search\" typeahead=\"project as project.title for project in projects | filter:$viewValue | limitTo:8\" typeahead-min-length=0 typeahead-on-select=\"selectProject($item, $model, $label)\" typeahead-template-url=/templates/projects/views/directives/project_search_single.html typeahead-append-to-body=true placeholder=\"{{ 'projects.views.directives.projectSearch.purojekuto_namataha_de' | translate }}\">";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects/views/directives/project_search.html
// module id = 1560
// module chunks = 0